import React from 'react';
import { Container } from 'react-bootstrap';
import { fadeIn } from '../../../Litho/Functions/GlobalAnimations';
import CustomIconWithText from '../../../Litho/Components/CustomIconWithText/CustomIconWithText';

const data = [
	{
		title: 'Real-time tracking',
		content: 'Live updates from pickup to delivery.',
		icon: 'line-icon-Map-Marker2',
	},
	{
		title: 'Route optimization',
		content: 'Efficient routing to reduce transit times.',
		icon: 'line-icon-Road-3',
	},
	{
		title: 'Secure transport',
		content: 'Monitored assets and sealed trailers.',
		icon: 'line-icon-Shield',
	},
	{
		title: 'Flexible capacity',
		content: 'Scale up with spot and dedicated options.',
		icon: 'line-icon-Full-Cart',
	},
	{
		title: 'Cross-border compliance',
		content: 'Expert documents and brokerage.',
		icon: 'line-icon-Paper',
	},
	{
		title: 'Sustainability options',
		content: 'Lower-emission fleets when available.',
		icon: 'line-icon-Leafs',
	},
];

const IconFeatures = () => {
	return (
		<section className='text-center relative grid-rows-3 grid-cols-2 py-[130px] opacity-[1] overflow-hidden bg-lightgray lg:py-[90px] sm:py-[75px] xs:py-[50px]'>
			<Container>
				<CustomIconWithText
					grid='row-cols-1 row-cols-lg-3 row-cols-sm-2'
					theme='custom-icon-with-text02'
					data={data}
					animationDelay={0.3}
					animation={fadeIn}
				/>
			</Container>
		</section>
	);
};

export default IconFeatures;
